import { NgModule } from '@angular/core';
import { FormButtonComponent } from '@common/components/FormButtonComponent/formButton.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    FormButtonComponent,
  ],
  imports: [
    TranslateModule,
  ],
  exports: [
    FormButtonComponent,
  ],
})
export class FormButtonModule {}



// WEBPACK FOOTER //
// ./src/app/common/components/FormButtonComponent/formButton.module.ts